import {Injectable} from '@angular/core';
import {CartItem} from '@features/sales/domain/entities/cart/cart-item.entity';
import {Product, ProductType} from '@features/sales/domain/models/product/product.model';
import {AddToCartOptions} from '@features/sales/domain/models/cart/item.model';
import {CartItemDTO} from '@features/sales/domain/models/cart/cart-item.model';

@Injectable({providedIn: 'root'})
export class CartItemFactory {
  fromProduct(product: Product, quantity: number, options?: AddToCartOptions): CartItem {
    const dto: CartItemDTO = {
      item: {
        id: product.id,
        price: product.price,
        type: product.type ?? ProductType.PRODUCT,
      },
      quantity,
      amount: 0,
      discount: options?.discount,
      customUnitPrice: options?.customUnitPrice,
      additionalProduct: options?.additionalProduct,
    };

    return new CartItem(dto);
  }
}
